import { getLocalFonts } from "./local-fonts.macro" with { type: "macro" };

export const localFonts = getLocalFonts();
const faces = localFonts.map(({ family, url }) => {
  const face = new FontFace(family, `url(${JSON.stringify(url)})`, { display: "swap" });
  document.fonts.add(face);
  return face;
});

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    for (const face of faces) document.fonts.delete(face);
  });
}
